import React, { forwardRef } from 'react';
import propTypes from 'prop-types';

const TextInput = forwardRef(({
  id,
  name,
  label,
  className = '',
  ...htmlProps
}, inputRef) => (
  <div className={className}>
    <div className="cmp-form__control-wrapper">
      <label htmlFor={id} className="cmp-form__control-label">
        {label}
      </label>
      <input
        id={id}
        type="text"
        name={name}
        className="cmp-form__input"
        ref={inputRef}
        {...htmlProps}
      />
    </div>
  </div>
));

TextInput.propTypes = {
  id: propTypes.string,
  name: propTypes.string,
  label: propTypes.string,
  className: propTypes.string,
};

export { TextInput };
